import { push } from 'connected-react-router';
import { Dispatch } from 'redux';

import {
	INavbarNoticeState,
	setNavbarNotices,
	showNavbarProgress,
} from '../actions/navbar';
import * as RootActions from '../actions/root';
import { Routes, Screens } from '../utils/Routes';
import Transfers from '../utils/Transfers';
import AbstractScenario from './AbstractScenario';

/**
 * ナビゲーションバーシナリオファクトリ
 */
export default class NavbarScenarioFactory {
	/**
	 * ログアウトシナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createLogout(
		dispatch: Dispatch,
		token: string,
		loginType: string
	) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{
			tsqWindow: Window | null;
		}> {
			protected process(arg: { tsqWindow: Window | null }) {
				dispatch(showNavbarProgress({ isShow: true }));
				return Transfers.logout().then(response => {
					dispatch(RootActions.initialize());
					dispatch(showNavbarProgress({ isShow: false }));
					if (loginType !== 'SSO') {
						dispatch(push(Routes.getPath(Screens.LOGIN)));
					} else {
						dispatch(push(Routes.getPath(Screens.LOGOUT)));
					}
					if (arg.tsqWindow && arg.tsqWindow.closed === false) {
						arg.tsqWindow.close();
					}
				});
			}
		}(dispatch, token);
		return scenario;
	}

	/**
	 * 通知メッセージ一覧取得シナリオ作成
	 * @param dispatch
	 * @param token
	 */
	public static createFetchNavbarNotices(dispatch: Dispatch, token: string) {
		// tslint:disable-next-line:max-classes-per-file
		const scenario = new class extends AbstractScenario<{}> {
			protected process(arg: {}) {
				return this.read('per_notice_ShowApplicationBlockModel').then(
					data => {
						const notices: INavbarNoticeState = {
							applyingCancelApplyCurriculumCnt:
								data.applyingCancelApplyCurriculumCnt,
							applyingCancelApplyTrainingCnt:
								data.applyingCancelApplyTrainingCnt,
							applyingPerformanceApplyTrainingCnt:
								data.applyingPerformanceApplyTrainingCnt,
							applyingStudentApplyCurriculumCnt:
								data.applyingStudentApplyCurriculumCnt,
							applyingStudentApplyTrainingCnt:
								data.applyingStudentApplyTrainingCnt,
							waitingPerformanceApprovalCnt:
								data.waitingPerformanceApprovalCnt,
							waitingStudentApprovalCnt:
								data.waitingStudentApprovalCnt,
							waitingStudentCancelCnt:
								data.waitingStudentCancelCnt,
						};
						dispatch(setNavbarNotices({ noticeState: notices }));
					}
				);
			}
		}(dispatch, token);
		return scenario;
	}
}



// WEBPACK FOOTER //
// ./src/scenario/NavbarScenarioFactory.ts